/*
	Use this module to load custom JS in the login page
*/

(function () {
	"use strict";

}());


// WEBPACK FOOTER //
// ./assets/js/custom/login.js